import React, { useState, useEffect } from "react";
import { FaPlus, FaSave, FaEdit, FaTrash } from "react-icons/fa";import ParticipantsDropdown from "../../DropDowns/ParticipantDropDown/ParticipantDropDown";
import AssetSelect from "../../DropDowns/AssetDropDown/ResourceAssetDropdown";
import ISODropdown from "../../DropDowns/ISODropdown/IsoDropdown";
import ResourceStatusDropdown from "../../DropDowns/ResourceDropdown/ResourceStatusDropdown";
import ResourceTypeDropdown from "../../DropDowns/ResourceDropdown/ResourceTypeDropdown";
import AncillaryServiceNodeDropdown from "../../DropDowns/AncillaryServiceNodeDropdown/AncillaryServiceNodeDropdown";
import Dialog from "../FormDialog/Dialog";
import BETMObjectKeyDropdown from "../../DropDowns/BETMObjectKey/BETMObjectkey";
import { getUserInfo } from "../../../services/authService-sighup";
import { RESOURCE_TAB } from "../constants/constants";
 
import AvailablePiMetricsDropdown from "../../DropDowns/AvailablePiMetricsDropdown/AvailablePiMetricsDropdown";
import apiClientTimeseries from "../../../services/apiClientTimeseries";
import { getHeaders as getMetricHeaders } from "../../ApiHeaders/apiHeadersTimeseries";

interface ResourceFormProps {
  onCreateResource: (resource: any) => void;
  onSaveResource: (resource: any) => void;
  selectedResource: any | null;
  onAssetChange: (asset: { asset_id: number; asset_name: string }) => void;
  onClearSelection: () => void;
  setSelectedResource: React.Dispatch<React.SetStateAction<any | null>>;
  onDirtyChange: (dirty: boolean) => void;
  onModeChange: (mode: 'create' | 'edit' | 'view' | null) => void;
  registerTabSwitchGuard?: (guard: () => boolean | Promise<boolean>) => void;
  // goToPIScreen: () => void;
  /** Opens PI Screen filtered to a resource. Unset when the user cannot see PI Screen, which hides the link. */
  goToPIScreen?: (resourceName?: string) => void;
  onDeleteResource: (resourceId: string) => void;
  canDelete?: boolean;
}
 
const ResourceForm: React.FC<ResourceFormProps> = ({
  onCreateResource,
  onSaveResource,
  selectedResource,
  onClearSelection,
  onAssetChange,
  setSelectedResource,
  onDirtyChange,
  onModeChange,
  registerTabSwitchGuard,
  goToPIScreen,
  onDeleteResource,
  canDelete = false,
}) => {
  const [resource, setResource] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  // const [selectedResourceType,setSelectedResourceType] = useState<string>("");
  const [piRecords, setPiRecords] = useState<any[]>([]);


  const [isoresourcename,setIsoresourcename] = useState("");
  const [isoresourceid,setIsoresourceid] = useState("");
  const [isopricenodename,setIsopricenodename] = useState("");
  const [isopricenodeid,setIsopricenodeid] = useState("");
  const [selectedbetmObjectKey, setselectedbetmObjectKey] = useState<number | "">("");
  const [betmObjectName, setBetmObjectName] = useState("");
  const [selectedParticipant, setSelectedParticipant] = useState<{ id: string; name: string } | null>(null);
  const [selectedIso, setSelectedIso] = useState("");
  const [selectedAncillaryId, setSelectedAncillaryId] = useState<number | "" | null>(null);
  const [selectedAsset, setSelectedAsset] = useState<{ asset_id: number; asset_name: string } | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [user, setUser] = useState<{ fullName: string; email: string } | null>(null);
  const [activeField, setActiveField] = useState<string | null>(null);
  const [modifiedFields, setModifiedFields] = useState<Record<string, boolean>>({});
  const [validationErrors, setValidationErrors] = useState<{
    resource: boolean;
    isoresourcename:boolean;
    isoresourceid:boolean;
    isopricenodename:boolean;
    isopricenodeid:boolean;
    selectedStatus:boolean;
    selectedbetmObjectKey: boolean;
    selectedParticipant: boolean;
    selectedIso: boolean;
    selectedAncillaryId:boolean;
    selectedAsset: boolean;
  }>({
    resource: false,
    isoresourceid:false,
    isoresourcename:false,
    isopricenodename:false,
    isopricenodeid:false,
    selectedStatus:false,
    selectedbetmObjectKey: false,
    selectedParticipant: false,
    selectedIso: false,
    selectedAncillaryId:false,
    selectedAsset: false,
  });
 
  const [dialog, setDialog] = useState<{
    open: boolean;
    title: string;
    message: string;
    confirmButtonText: string;
    cancelButtonText?: string;
    onConfirm: () => void;
    onCancel?: () => void;
  }>({
    open: false,
    title: "",
    message: "",
    confirmButtonText: "",
    onConfirm: () => { },
  });
 
  useEffect(() => {
    if (selectedAsset) {
      onAssetChange(selectedAsset);
 
    }
 
  }, [selectedAsset]);
 
  const closeDialog = () => {
    setDialog({
      open: false,
      title: "",
      message: "",
      confirmButtonText: "",
      onConfirm: () => { },
    });
  };
  useEffect(() => {
    const fetchUserInfo = () => {
      const userInfo = getUserInfo();
      if (userInfo) {
        setUser({
          fullName: userInfo.fullName || "Unknown User",
          email: userInfo.email || "",
        });
      }
    };
    fetchUserInfo();
  }, []);
 
  const createdBy = user ? `${user.email || user.fullName}` : "Unknown User";
  const modifiedBy = user ? `${user.email || user.fullName}` : "Unknown User";
 
 
  useEffect(() => {
    // if (selectedResource) {
    //   if (!isEditMode) {
    // console.log(" [DEBUG] selectedResource changed:", selectedResource);
    if (selectedResource && !isEditMode) {
      // console.log("ancillary_service_node_id from selectedResource:", selectedResource.ancillary_service_node_id);
      setResource(selectedResource.resource_type_code);
      setIsoresourcename(selectedResource.iso_resource_name);
      setIsoresourceid(selectedResource.iso_resource_id);
      setIsopricenodename(selectedResource.iso_price_node_name);
      setIsopricenodeid(selectedResource.iso_price_node_id);
      setSelectedStatus(selectedResource.resource_status_code);
      setselectedbetmObjectKey(selectedResource.betm_object_id);
      setBetmObjectName(selectedResource.betm_object_name || "");
      setSelectedParticipant({
        id: selectedResource.participant_id || "",
        name: selectedResource.participant_name || "",
      });
      setSelectedAsset({
        asset_id: selectedResource.asset_id,
        asset_name: selectedResource.asset_name,
      });
      setIsViewMode(true);
      onDirtyChange(false);
      setSelectedIso(selectedResource.iso_code);
      // console.log(" ancillary_service_node_id from selectedResource:", selectedResource.ancillary_service_node_id);
      // console.log(" region_id from selectedResource:", selectedResource.region_id);
      // setSelectedAncillaryId(selectedResource?.region_id);
      const timer = setTimeout(() => {
        // console.log(" Setting region_id after ISO:", selectedResource.region_id);
        // setSelectedAncillaryId(selectedResource?.region_id);
        setSelectedAncillaryId(selectedResource?.region_id ?? null);
      }, 300);
      return () => clearTimeout(timer);
      // setIsEditMode(false);
      // } else if (isEditMode) {
    } else if (selectedResource && isEditMode) {
      setResource(selectedResource.resource_type_code);
      setIsoresourcename(selectedResource.iso_resource_name);
      setIsoresourceid(selectedResource.iso_resource_id);
      setIsopricenodename(selectedResource.iso_price_node_name);
      setIsopricenodeid(selectedResource.iso_price_node_id);
      setSelectedStatus(selectedResource.resource_status_code);
      setselectedbetmObjectKey(selectedResource.betm_object_id);
      setBetmObjectName(selectedResource.betm_object_name || "");
      setSelectedParticipant({
        id: selectedResource.participant_id || "",
        name: selectedResource.participant_name || "",
      });
      setSelectedIso(selectedResource.iso_code);
      setSelectedAsset({
        asset_id: selectedResource.asset_id,
        asset_name: selectedResource.asset_name,
      });
      setIsEditMode(false);
      setIsViewMode(true);
      // console.log("region_id from selectedResource:", selectedResource.region_id);
      // setSelectedAncillaryId(selectedResource?.region_id);
      const timer = setTimeout(() => {
        // console.log(" Setting region_id after ISO:", selectedResource.region_id);
        // setSelectedAncillaryId(selectedResource?.region_id);
        setSelectedAncillaryId(selectedResource?.region_id ?? null);
      }, 300);
      return () => clearTimeout(timer);
      //     }
      //   } else {
      //     resetForm();
      //   }
      // }, [selectedResource]);
    }
  }, [selectedResource]);
  const resetForm = () => {
    setResource("");
    setIsoresourcename("");
    setIsoresourceid("");
    setIsopricenodename("");
    setIsopricenodeid("");
    setSelectedStatus("");
    setselectedbetmObjectKey("");
    setSelectedParticipant(null);
    setSelectedIso("");
    setSelectedAncillaryId("");
    setSelectedAsset(null);
    setValidationErrors({
      resource: false,
      isoresourcename:false,
      isoresourceid:false,
      isopricenodename:false,
      isopricenodeid:false,
      selectedStatus:false,
      selectedbetmObjectKey: false,
      selectedParticipant: false,
      selectedIso: false,
      selectedAncillaryId:false,
      selectedAsset: false,
    });
    setIsEditMode(false);
    setIsViewMode(false);
    onDirtyChange(false); 
    onModeChange(null);
    setModifiedFields({});
    // onClearSelection();
    setSelectedResource('');
  };
 
  const validateFields = () => {
    const errors = {
      resource: !resource,
      isoresourcename: !isoresourcename,
      isoresourceid:!isoresourceid,
      isopricenodename:!isopricenodename,
      isopricenodeid:!isopricenodeid,
      selectedStatus:!selectedStatus,
      selectedbetmObjectKey: !selectedbetmObjectKey,
      selectedParticipant: !selectedParticipant?.name,
      selectedIso: !selectedIso,
      selectedAncillaryId:!selectedAncillaryId,
      selectedAsset: !selectedAsset,
    };
    setValidationErrors(errors);
    return !Object.values(errors).some((error) => error);
  };
 
  const handleSubmit = () => {
    if (!validateFields()) {
      setDialog({
        open: true,
        title: RESOURCE_TAB.VALIDATION.MISSING_INFO_TITLE,
        message: RESOURCE_TAB.VALIDATION.MISSING_INFO_MESSAGE,
        confirmButtonText: "Close",
        onConfirm: closeDialog,
      });
      return;
    }
 
    const resourceData = {
      resource_type_code: resource,
      // resource_status_code:setSelectedStatus,
      iso_price_node_name:isopricenodename,
      iso_price_node_id:isopricenodeid,
      iso_resource_name:isoresourcename,
      iso_resource_id:isoresourceid,
      resource_status_code:selectedStatus,
      betm_object_id: selectedbetmObjectKey,
      betm_object_name: betmObjectName,
      participant_name: selectedParticipant?.name,
      participant_id: selectedParticipant?.id,
      asset_id: selectedAsset?.asset_id,
      iso_code: selectedIso,
      region_id: selectedAncillaryId || null,
      asset_name: selectedAsset?.asset_name,
      sys_created_by: createdBy,
      sys_modified_by: modifiedBy,
    };
 
    // if (isEditMode) {
    //   updateResource(resourceData);
    // } else {
    //   createResource(resourceData);
    // }
    if (isEditMode) {
      setDialog({
        open: true,
        title: RESOURCE_TAB.DIALOGS.CONFIRM_EDIT_TITLE,
        message: RESOURCE_TAB.DIALOGS.CONFIRM_EDIT_MESSAGE,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        onConfirm: () => {
          updateResource(resourceData);
          setModifiedFields({});
        },
        onCancel: closeDialog
      });
    } else {
      setDialog({
        open: true,
        title: RESOURCE_TAB.DIALOGS.CONFIRM_CREATE_TITLE,
        message: RESOURCE_TAB.DIALOGS.CONFIRM_CREATE_MESSAGE,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        onConfirm: () => {
          createResource(resourceData);;
          closeDialog();
          resetForm();
        },
        onCancel: closeDialog
      });
    }
  };
 
  const createResource = (resourceData: any) => {
    onCreateResource(resourceData);
    // onClearSelection();
    setIsViewMode(true);
    setIsEditMode(false);
    setSelectedResource(null);
    onDirtyChange(false);
    closeDialog();
  };
 
  const updateResource = (resourceData: any) => {
    onSaveResource({
      ...resourceData,
      resource_id: selectedResource?.resource_id,
    });
    // onClearSelection();
    setIsViewMode(true);
    setIsEditMode(false);
    setSelectedResource(null);
    onDirtyChange(false);
    setModifiedFields({});
    closeDialog();
  };
 
 
  // console.log("selected resource", selectedResource)
 
  const handleEdit = () => {
    setIsEditMode(true);
    setIsViewMode(false);
    onDirtyChange(true); 
    setModifiedFields({});
    onModeChange('edit');
  };
  const resetToSelectedCompany = () => {
    if (selectedResource) {
        setResource(selectedResource.resource_type_code);
        setIsoresourcename(selectedResource.iso_resource_name);
        setIsoresourceid(selectedResource.iso_resource_id);
        setIsopricenodename(selectedResource.iso_price_node_name);
        setIsopricenodeid(selectedResource.iso_price_node_id);
        setSelectedStatus(selectedResource.resource_status_code);
        setselectedbetmObjectKey(selectedResource.betm_object_id);
        setBetmObjectName(selectedResource.betm_object_name || "");
        setSelectedParticipant({
          id: selectedResource.participant_id || "",
          name: selectedResource.participant_name || "",
        });
        // console.log("region_id from selectedResource:", selectedResource.region_id);
        // setSelectedAncillaryId(selectedResource?.region_id);
        setSelectedAncillaryId(selectedResource?.region_id ?? null);
        setSelectedIso(selectedResource.iso_code);
        setSelectedAsset({
          asset_id: selectedResource.asset_id,
          asset_name: selectedResource.asset_name,
        });
      setIsEditMode(false);
      setIsViewMode(true);
      setModifiedFields({});
      onDirtyChange(false);
      onModeChange("view");
    }
  };
  
  const handleCancelClick = () => {
    setDialog({
      open: true,
      title: "Cancel Editing?",
      message: "Are you sure you want to discard changes?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        closeDialog();
        resetToSelectedCompany();
        setModifiedFields({});
      },
      onCancel: closeDialog,
    });
  };
  const handleNew = () => {
    setDialog({
      open: true,
      title: RESOURCE_TAB.DIALOGS.CONFIRM_NEW_TITLE,
      message: RESOURCE_TAB.DIALOGS.CONFIRM_NEW_MESSAGE,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        closeDialog();
        resetForm();
        setIsEditMode(false);
        // onModeChange('create');
        onDirtyChange(false);
        onClearSelection();
        setModifiedFields({});
      },
      onCancel: closeDialog,
    });
  };
 
  const inputClass = (field: keyof typeof validationErrors) =>
    `w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200 ${validationErrors[field]
      ? "border-red-500 bg-red-50"
      : isEditMode
        ? "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
        : isEditMode && activeField === "resource"
        ? "border-green-500 focus:ring-2 focus:ring-green-500"
        : "bg-[#f9f9f9] text-gray-800 border-gray-300"
    }`;
 
    const dropdownClass = (field: keyof typeof validationErrors) =>
      `w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 ${validationErrors[field]
        ? "border-red-500 bg-red-50"
        : isEditMode
          ? "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
          : "bg-[#f9f9f9] text-gray-800 border-gray-300"
      }`;
 
      
      const fetchPIRecords = async () => {
        try {
          const headers = await getMetricHeaders();
      
          const response = await apiClientTimeseries.get(
            `/metric-resource/pi-metric-resource`,
            { headers }
          );
      
          const data = response?.data?.response?.data || [];
      
          const validPIRecords = data.filter(
            (r: any) => r.PI_METRIC_ID !== null && r.PI_METRIC_ID !== undefined
          );
      
          setPiRecords(validPIRecords);
        } catch (err) {
        }
      };
      
      useEffect(() => {
        fetchPIRecords();
      }, []);
      
      // Without admin the form is view-only: every field stays disabled.
      const fieldsLocked = !canDelete || (isViewMode && !isEditMode);

      const handleDeleteClick = () => {
        if (!selectedResource) return;
      
        setDialog({
          open: true,
          title: "Confirm Delete",
          message: "Are you sure you want to delete this Resource?",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          onConfirm: () => {
            onDeleteResource(selectedResource.resource_id);
            closeDialog();
            resetForm();
          },
          onCancel: closeDialog,
        });
      };
    
 
  return (
    // <div className="font-poppins w-full max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md overflow-visible">
    <div className="font-poppins w-full  mx-auto p-6 bg-white rounded-lg shadow-md overflow-visible">

      {dialog.open && (
        <Dialog
          title={dialog.title}
          message={dialog.message}
          confirmButtonText={dialog.confirmButtonText}
          cancelButtonText={dialog.cancelButtonText}
          onConfirm={dialog.onConfirm}
          onCancel={dialog.onCancel}
          onClose={closeDialog}
        />
      )}
<div className="flex justify-between items-center gap-4 mb-4">

<div>
  {isEditMode && canDelete && (
    <button
      onClick={handleDeleteClick}
      type="button"
      className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600"
    >
      <FaTrash className="w-4 h-4" />
      Delete
    </button>
  )}
</div>

<div className="flex gap-4">  {canDelete && !isViewMode && !isEditMode && (
    <button
      onClick={handleSubmit}
      className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
    >
      <FaPlus className="w-4 h-4" />
      Create
    </button>
  )}

  {canDelete && isViewMode && !isEditMode && (
    <>
      <button
        onClick={handleNew}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        <FaPlus className="w-4 h-4" />
        New
      </button>

      <button
        onClick={handleEdit}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        <FaEdit className="w-4 h-4" />
        Edit
      </button>
    </>
  )}

  {canDelete && isEditMode && (
    <>
      <button
        onClick={handleSubmit}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        <FaSave className="w-4 h-4" />
        Save
      </button>

      <button
        onClick={handleCancelClick}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        Cancel
      </button>
    </>
  )}
</div>
</div>

 <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
  <div>
    <label className="block text-gray-600 mb-2 font-medium">Asset<span className="text-red-500 text-lg align-top ml-1">*</span></label>
          <AssetSelect
            selectedAssetId={selectedAsset?.asset_id || ""}
            selectedAsset={selectedAsset}
            // onAssetSelect={setSelectedAsset}
            onAssetSelect={(value) => {
              setSelectedAsset(value);
              onDirtyChange(true);
              setModifiedFields(prev => ({ ...prev, selectedAsset: true }));
              if (!modifiedFields.selectedIso && value?.iso_code) {
                setSelectedIso(value.iso_code);
              }
            }}
            onFocus={() => setActiveField("selectedAsset")}
            disabled={fieldsLocked}
            // className={dropdownClass("selectedAsset")}
            className={`w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 
            ${validationErrors.selectedAsset && !selectedAsset
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "selectedAsset"|| modifiedFields.selectedAsset)
              ? "border-green-500 focus:ring-2 focus:ring-green-500"
              : !isEditMode
                ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`
            }
          />
 
  </div>
  <div>
  <label className="block text-gray-600 mb-2 font-medium">
    Resource Status Code
    <span className="text-red-500 text-lg align-top ml-1">*</span>
  </label>

  {/* <ResourceStatusDropdown
    selectedStatus={selectedStatus}
    onStatusSelect={(value) => {
      setSelectedStatus(value);
      onDirtyChange(true);
      setModifiedFields(prev => ({ ...prev, selectedStatus: true }));
    }} */}
    <ResourceStatusDropdown
  selectedStatus={selectedStatus}
  onStatusChange={(value) => {
    setSelectedStatus(value);
    onDirtyChange(true);
    setModifiedFields((prev) => ({ ...prev, selectedStatus: true }));
  }}
    onFocus={() => setActiveField("selectedStatus")}
    disabled={fieldsLocked}
    className={`w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 
      ${validationErrors.selectedStatus && !selectedStatus
        ? "border-red-500 focus:ring-red-500"
        : isEditMode && (activeField === "selectedStatus" || modifiedFields.selectedStatus)
        ? "border-green-500 focus:ring-2 focus:ring-green-500"
        : !isEditMode
          ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
          : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
      }`}
  />
</div>
 </div>
 <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
        <div>
          <label className="block text-gray-600 mb-2 font-medium">Participant<span className="text-red-500 text-lg align-top ml-1">*</span></label>
          <ParticipantsDropdown
            selectedParticipant={selectedParticipant?.name || ""}
            onParticipantChange={(participant) => {
              setSelectedParticipant(participant);
              onDirtyChange(true);
              setModifiedFields(prev => ({ ...prev, selectedParticipant: true })); 
            }}
            onFocus={() => setActiveField("selectedParticipant")}
            disabled={fieldsLocked}
            // className={dropdownClass("selectedParticipant")}
            className={`w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 
            ${validationErrors.selectedParticipant && !selectedParticipant
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "selectedParticipant"|| modifiedFields.selectedParticipant)
              ? "border-green-500 focus:ring-2 focus:ring-green-500"
              : !isEditMode
                ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`
            }
          />
 
        </div>
        <div>
          <label className="block text-gray-600 mb-2 font-medium">Resource Type<span className="text-red-500 text-lg align-top ml-1">*</span></label>
          <ResourceTypeDropdown
            selectedType={resource}
            onTypeChange={(value) => {
              setResource(value);
              onDirtyChange(true);
              setModifiedFields((prev) => ({ ...prev, resource: true }));
            }}
            onFocus={() => setActiveField("resource")}
            disabled={fieldsLocked}
            className={`w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 
    ${validationErrors.resource && !resource
                ? "border-red-500 focus:ring-red-500"
                : isEditMode && (activeField === "resource" || modifiedFields.resource)
                  ? "border-green-500 focus:ring-2 focus:ring-green-500"
                  : !isEditMode
                    ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                    : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`}
          />
        </div>
        </div>
        {/* <div className="grid grid-cols-1 sm:[grid-template-columns:repeat(2,minmax(0,1fr))_auto] : sm:grid-cols-2 gap-6 mt-4"> */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
  <div>
    <label className="block text-gray-600 mb-2 font-medium">ISO<span className="text-red-500 text-lg align-top ml-1">*</span></label>
    <ISODropdown
            selectedISO={selectedIso}
            // onISOChange={setSelectedIso}
            onISOChange={(iso) => {
              setSelectedIso(iso);
              onDirtyChange(true); 
              setModifiedFields(prev => ({ ...prev, selectedIso: true }));
            }}
            onFocus={() => setActiveField("selectedIso")}
            disabled={fieldsLocked}
            // className={dropdownClass("selectedIso")}
            className={`w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 
            ${validationErrors.selectedIso && !selectedIso
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "selectedIso"|| modifiedFields.selectedIso)
              ? "border-green-500 focus:ring-2 focus:ring-green-500"
              : !isEditMode
                ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`
            }
          />
 
  </div>
  {/* <div> */}
    {/* <label className="block text-gray-600 mb-2 font-medium">Resource Type<span className="text-red-500 text-lg align-top ml-1">*</span></label> */}
    {/* <input
            type="text"
            value={resource}
            // onChange={(e) => setResource(e.target.value)}
            onChange={(e) => {
              setResource(e.target.value);
              onDirtyChange(true); 
              setModifiedFields(prev => ({ ...prev, resource: true }));
            }}
            placeholder="Enter resource name"
            onFocus={() => setActiveField("resource")}
            disabled={isViewMode && !isEditMode}
            // className={inputClass("resource")}
            className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200
            ${validationErrors.resource && !resource
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "resource"|| modifiedFields.resource)
              ? "border-green-500 focus:ring-2 focus:ring-green-500"
              : !isEditMode
                ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`
            }
          /> */}
          {/* <ResourceTypeDropdown
  selectedType={resource}
  onTypeChange={(value) => {
    setResource(value);
    onDirtyChange(true);
    setModifiedFields((prev) => ({ ...prev, resource: true }));
  }}
  onFocus={() => setActiveField("resource")}
  disabled={isViewMode && !isEditMode}
  className={`w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 
    ${validationErrors.resource && !resource
      ? "border-red-500 focus:ring-red-500"
      : isEditMode && (activeField === "resource" || modifiedFields.resource)
      ? "border-green-500 focus:ring-2 focus:ring-green-500"
      : !isEditMode
        ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
        : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
    }`}
/>

 
  </div> */}
  <div>
          <label className="block text-gray-600 mb-2 font-medium">
            Ancillary Service Node<span className="text-red-500 text-lg align-top ml-1">*</span>
          </label>
          <AncillaryServiceNodeDropdown
            selectedISO={selectedIso}
            // selectedAncillaryId={selectedAncillaryId}yy
            selectedAncillaryId={selectedAncillaryId ?? ""}

            onNodeChange={(value, nodeObj) => {
              setSelectedAncillaryId(value);
              onDirtyChange(true);
              setModifiedFields((prev) => ({ ...prev, selectedAncillaryId: true }));
            }}
            disabled={fieldsLocked}
            className={`w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 
    ${validationErrors.selectedAncillaryId && !selectedAncillaryId
                ? "border-red-500 focus:ring-red-500"
                : isEditMode && (activeField === "selectedAncillaryId" || modifiedFields.selectedAncillaryId)
                  ? "border-green-500 focus:ring-2 focus:ring-green-500"
                  : !isEditMode
                    ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                    : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`}
          />
        </div>
 </div>
 <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
  <div>
<label className="block text-gray-600 mb-2 font-medium">ISO Resource Name<span className="text-red-500 text-lg align-top ml-1">*</span></label>
<input
            type="text"
            value={isoresourcename}
            // onChange={(e) => setResource(e.target.value)}
            onChange={(e) => {
              setIsoresourcename(e.target.value);
              onDirtyChange(true); 
              setModifiedFields(prev => ({ ...prev, isoresourcename: true }));
            }}
            placeholder="Enter ISO Resource Name"
            onFocus={() => setActiveField("isoresourcename")}
            disabled={fieldsLocked}
            // className={inputClass("resource")}
            className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200
            ${validationErrors.isoresourcename && !isoresourcename
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "isoresourcename"|| modifiedFields.isoresourcename)
              ? "border-green-500 focus:ring-2 focus:ring-green-500"
              : !isEditMode
                ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`
            }
          />

</div>
<div>
<label className="block text-gray-600 mb-2 font-medium">ISO Resource ID<span className="text-red-500 text-lg align-top ml-1">*</span></label>
<input
            type="text"
            value={isoresourceid}
            // onChange={(e) => setResource(e.target.value)}
            onChange={(e) => {
              setIsoresourceid(e.target.value);
              onDirtyChange(true); 
              setModifiedFields(prev => ({ ...prev, isoresourceid: true }));
            }}
            placeholder="Enter ISO Resource ID"
            onFocus={() => setActiveField("isoresourceid")}
            disabled={fieldsLocked}
            // className={inputClass("resource")}
            className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200
            ${validationErrors.isoresourceid && !isoresourceid
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "isoresourceid"|| modifiedFields.isoresourceid)
              ? "border-green-500 focus:ring-2 focus:ring-green-500"
              : !isEditMode
                ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`
            }
          />
</div>
</div>
<div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
  <div>
<label className="block text-gray-600 mb-2 font-medium">ISO Price Node Name<span className="text-red-500 text-lg align-top ml-1">*</span></label>
<input
            type="text"
            value={isopricenodename}
            // onChange={(e) => setResource(e.target.value)}
            onChange={(e) => {
              setIsopricenodename(e.target.value);
              onDirtyChange(true); 
              setModifiedFields(prev => ({ ...prev, isopricenodename: true }));
            }}
            placeholder="Enter ISO Price Node Name"
            onFocus={() => setActiveField("isopricenodename")}
            disabled={fieldsLocked}
            // className={inputClass("resource")}
            className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200
            ${validationErrors.isopricenodename && !isopricenodename
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "isopricenodename"|| modifiedFields.isopricenodename)
              ? "border-green-500 focus:ring-2 focus:ring-green-500"
              : !isEditMode
                ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`
            }
          />

</div>
<div>
<label className="block text-gray-600 mb-2 font-medium">ISO Price Node ID<span className="text-red-500 text-lg align-top ml-1">*</span></label>
<input
            type="text"
            value={isopricenodeid}
            // onChange={(e) => setResource(e.target.value)}
            onChange={(e) => {
              setIsopricenodeid(e.target.value);
              onDirtyChange(true); 
              setModifiedFields(prev => ({ ...prev, isopricenodeid: true }));
            }}
            placeholder="Enter ISO Price Node ID"
            onFocus={() => setActiveField("isopricenodeid")}
            disabled={fieldsLocked}
            // className={inputClass("resource")}
            className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200
            ${validationErrors.isopricenodeid && !isopricenodeid
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "isopricenodeid"|| modifiedFields.isopricenodeid)
              ? "border-green-500 focus:ring-2 focus:ring-green-500"
              : !isEditMode
                ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`
            }
          />
</div>
</div>

<div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
  <div>
  <label className="block text-gray-600 mb-2 font-medium">BETM Object Name<span className="text-red-500 text-lg align-top ml-1">*</span></label>
          <BETMObjectKeyDropdown
            selectedBETMObjectKey={selectedbetmObjectKey}
            onBETMObjectChange={(selectedName, selectedKey) => {
              setselectedbetmObjectKey(selectedKey);
              setBetmObjectName(selectedName);
              onDirtyChange(true); 
              setModifiedFields(prev => ({ ...prev, selectedbetmObjectKey: true }));
            }}
            onFocus={() => setActiveField("selectedbetmObjectKey")}
            disabled={fieldsLocked}
            // className={dropdownClass("selectedbetmObjectKey")}
            className={`w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 
            ${validationErrors.selectedbetmObjectKey && !selectedbetmObjectKey
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "selectedbetmObjectKey"|| modifiedFields.selectedbetmObjectKey)
              ? "border-green-500 focus:ring-2 focus:ring-green-500"
              : !isEditMode
                ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`
            }
          />
  </div>
  <div>
  <label className="block text-gray-600 mb-2 font-medium">BETM Object Key</label>
  <input
    type="text"
    value={selectedbetmObjectKey}
    disabled
    className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200 
      ${validationErrors.selectedbetmObjectKey && !selectedbetmObjectKey
        ? "border-red-500 focus:ring-red-500"
        : isEditMode && (activeField === "selectedbetmObjectKey" || modifiedFields.selectedbetmObjectKey)
        ? "border-green-500 focus:ring-2 focus:ring-green-500"
        : !isEditMode
          ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
          : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
      }`}
  />
  </div>
</div>
{(isViewMode || isEditMode) && (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4 items-center">
    
    <div>
    <label className="block text-gray-600 mb-2 font-medium">
          Available PI Metrics
        </label>

        <AvailablePiMetricsDropdown
          piRecords={piRecords}
          selectedResourceName={isoresourcename}
          className="w-full p-1 border rounded-lg shadow-inner text-sm 
                     bg-[#f9f9f9] text-gray-800 border-gray-300"
        />
    </div>

    {/* Only navigates: PI Screen opens with its search set to this resource. */}
    {goToPIScreen && (
    <div className="flex justify-center items-center">
        <button
      onClick={() => goToPIScreen(isoresourcename)}
      className="text-red-500 font-medium hover:underline hover:text-red-700 transition"
      >
      PI Point Setup →
      </button>
    </div>
    )}

  </div>
)}



      
    </div>
  );
};
 
export default ResourceForm;